import React, { FC, ReactElement } from 'react';
import { Container, Typography } from '@material-ui/core';
import { stylesCalculator } from '../../styles/calculator';
import * as Logo from '../../assets/img/logo.jpg';

interface CalculatorProps {
    children: ReactElement;
}

const Calculator: FC<CalculatorProps> = (props: CalculatorProps) => {
    const { children } = props;
    const classes = stylesCalculator();

    return (
        <Container maxWidth={'md'}>
            <div className={classes.titleContainer}>
                <img src={Logo} className={classes.logo} alt="" />
                <Typography className={classes.title} align="center" variant="h4" component="div">
                    Calculadora da Previdência
                </Typography>
            </div>

            {children}
        </Container>
    );
};

export default Calculator;
